const ProjectMap = require('./project_map');
const AssetSummary = require('./asset_summary');
const AssetTable = require('./asset_table');
const AssetSearch = require('./asset_search');
const AssetFilter = require('./asset_filter');
const Geocoder = require('../common/geocoder');
const _ = require('underscore');
const $ = require('jquery');

class ProjectMapController {
  constructor(
    $toggleDashboard,
    $assetSummary,
    $assetTable,
    $addressInput,
    $addressSubmit,
    quickEdit = null,
    external,
    assetSearchUrl,
    legendValues,
    kmzFiles,
  ) {
    const self = this;

    this.counter = $('#asset-count');
    this.map = new ProjectMap(
      $('#asset-map'),
      _.bind(this.boundsChangedCallback, this),
      legendValues,
      _.bind(this.assetSelected, this),
      kmzFiles,
      external,
    );
    this.summary = new AssetSummary(
      $assetSummary,
      _.bind(this.filterAssets, this),
      _.bind(this.clearFilters, this),
    );
    this.table = new AssetTable($assetTable, external);
    this.assetSearch = new AssetSearch(
      $('#status-message'),
      assetSearchUrl,
      (assets, data_summary, user_locations) =>
        self.addAssets(assets, data_summary, user_locations),
    );
    this.assetFilter = new AssetFilter();
    this.quickEdit = quickEdit;

    this.assetSearchUrl = assetSearchUrl;
    this.assets = [];

    new Geocoder(
      $addressInput,
      $addressSubmit,
      _.bind(self.onGeocoderSuccess, self),
    );

    // To start things off, grab the current position and center the map
    // on the user. Then, find the nearest assets and plot those on the map,
    // finally start listening to the bounds_changed event
    this.setCurrentLocation(
      function (position) {
        self.currentLat = position.coords.latitude;
        self.currentLng = position.coords.longitude;
        return self.map.setMapPosition(self.currentLat, self.currentLng);
      },
      (err) =>
        console.warn('Geolocation error (' + err.code + '): ' + err.message),
    );
    // If location services is turned off set map to default lat/lng
    self.currentLat = window.default_latitude;
    self.currentLng = window.default_longitude;

    self.map.setMapPosition(self.currentLat, self.currentLng);
    self.map.setCenterLocation(self.currentLat, self.currentLng);

    if ($assetSummary.length > 0 && $toggleDashboard.length > 0) {
      $assetTable.hide();

      $toggleDashboard.click(() => {
        $assetSummary.toggle();
        $assetTable.toggle();

        if ($assetSummary.is(':visible')) {
          return $toggleDashboard.html('Show Assets');
        } else {
          return $toggleDashboard.html('Show Summary');
        }
      });
    } else {
      $assetTable.show();
    }
  }

  setCurrentLocation(successCallback, errorCallback) {
    if (navigator.geolocation) {
      return navigator.geolocation.getCurrentPosition(
        successCallback,
        errorCallback,
      );
    } else {
      return errorCallback();
    }
  }

  clearFilters() {
    this.assetFilter.clearFilters();
    return this.refreshAssets();
  }

  filterAssets($el, method, value) {
    this.assetFilter.filterAssets($el, method, value);
    return this.refreshAssets();
  }

  refreshAssets() {
    const bounds = this.map.map.getBounds();
    return this.getAssetsByBounds(bounds);
  }

  boundsChangedCallback(newBounds) {
    return this.getAssetsByBounds(newBounds);
  }

  getAssetsByBounds(bounds) {
    const filters = $.extend({}, this.assetFilter.getFilters());
    if (navigator.geolocation) {
      return this.assetSearch.getAssetsByPositionBounds(bounds, filters, {
        lat: this.currentLat,
        lng: this.currentLng,
      });
    } else {
      return this.assetSearch.getAssetsByPositionBounds(bounds, filters);
    }
  }

  addAssets(newAssets, assetsSummary, userLocations) {
    this.counter.text(newAssets.length);
    this.summary.updateSummary(assetsSummary, this.assetFilter.getFilters());
    this.table.addAssets(newAssets);
    this.map.clearAllMarkers();
    this.map.setMarkersForUsers(userLocations);
    return this.map.setMarkersFromAssets(newAssets);
  }

  assetSelected(asset) {
    if (this.quickEdit) {
      this.quickEdit.setupForAsset(asset);
    }
    this.setAddressQueryParam(asset.address);
  }

  onGeocoderSuccess(pos, address) {
    this.map.centerMapOnPosition(pos);
    this.setAddressQueryParam(address);
  }

  setAddressQueryParam(address) {
    const queryParams = new URLSearchParams({ address });

    window.history.replaceState(null, null, '?' + queryParams.toString());
  }
}

window.ProjectMapController = ProjectMapController;
